<script>

  import { Doughnut, mixins } from 'vue-chartjs'

  export default {
    name: 'pie-chart',

    props: ['chartData', 'options'],

    mixins: [Doughnut, mixins.reactiveProp],
    data () {
      return {

      }
    },

    mounted () {
      // this.chartData is created in the mixin
      this.renderChart(this.chartData, this.options)
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/charts/pie-chart.vue